import { toRaw } from 'vue'

const SET_USER_PROFILE = (state, profile) => {
  toRaw(state).loggedInUser = profile;
};

export default {
  SET_USER_PROFILE,
}